module.exports = __webpack_public_path__ + "img/Audio.38c8e0c2.svg";